export interface mailFormDataTypes {
  firstname: string,
  lastname: string,
  email: string,
  company: string,
  privacyCheckbox: boolean,
  marketingCheckbox: boolean,
}

export const mailFormData: mailFormDataTypes = {
  firstname: "",
  lastname: "",
  email: "",
  company: "",
  privacyCheckbox: false,
  marketingCheckbox: false,
};